var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1516 15.9976H0.615288C0.275649 15.9976 0 15.722 0 15.3823V1.846C0 1.50636 0.275649 1.23071 0.615288 1.23071H7.99875C8.33839 1.23071 8.61404 1.50636 8.61404 1.846C8.61404 2.18564 8.33839 2.46129 7.99875 2.46129H1.23058V14.7671H13.5363V7.99889C13.5363 7.65925 13.812 7.3836 14.1516 7.3836C14.4913 7.3836 14.7669 7.65925 14.7669 7.99889V15.3823C14.7669 15.722 14.4913 15.9976 14.1516 15.9976Z",
    fill: "#F7921E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38401 11.0755H5.53814C5.1985 11.0755 4.92285 10.7998 4.92285 10.4602V8.61434C4.92285 8.45068 4.98807 8.29439 5.10252 8.17872L13.1013 0.179972C13.3412 -0.0599906 13.7313 -0.0599906 13.9713 0.179972L15.8171 2.02584C16.0571 2.2658 16.0571 2.65589 15.8171 2.89586L7.8184 10.8946C7.70396 11.0103 7.54767 11.0755 7.38401 11.0755ZM6.15343 9.84492H7.12928L14.5127 2.46146L13.5369 1.48561L6.15343 8.86907V9.84492Z",
    fill: "#F7921E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.537 4.92206C13.3795 4.92206 13.222 4.86175 13.1013 4.74237L11.2552 2.89622C11.0152 2.65622 11.0152 2.26607 11.2552 2.02607C11.4952 1.78607 11.8853 1.78607 12.1253 2.02607L13.9715 3.87222C14.2115 4.11222 14.2115 4.50237 13.9715 4.74237C13.8521 4.86175 13.6946 4.92206 13.537 4.92206Z",
    fill: "#F7921E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b3244845c9dc2a4fd54373e993c196ee.svg";
export { ForwardRef as ReactComponent };